<div *ngIf="ccLicenseGranted" style="margin: 10px;">
  <img [src]="ccLogoImgSrc" [alt]="ccLicenseName">
</div>
